import React, { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';
import PageRoute from 'components/Routes/PageRoute';
import { featureTogglesRoutePerm } from 'components/Routes/routePermissions';
import { UserCapabilityName } from 'types/userCapabilityName';

const ProgressiveDelivery = lazy(
  () =>
    import(
      /* webpackChunkName: "progressive-delivery-page" */ './ProgressiveDelivery'
    )
);

const ProgressiveDeliveryCreate = lazy(
  () =>
    import(
      /* webpackChunkName: "progressive-delivery-create-page" */ './ProgressiveDeliveryCreate'
    )
);

const ProgressiveDeliveryCalendar = lazy(
  () =>
    import(
      /* webpackChunkName: "progressive-delivery-calendar-page" */ './ProgressiveDeliveryCalendar'
    )
);

const { userCapabilities } = featureTogglesRoutePerm;

export const progressiveDeliveryRoutes = (
  <Route path="progressive-delivery/*">
    <Route
      path=""
      element={
        <PageRoute
          userCapabilities={userCapabilities}
          pageInfo={{ title: 'Progressive Delivery' }}
        >
          <ProgressiveDelivery />
        </PageRoute>
      }
    />
    <Route
      path="create"
      element={
        <PageRoute
          userCapabilities={[UserCapabilityName.FeatureToggleAdmin]}
          pageInfo={{ title: 'New Progressive Delivery' }}
        >
          <ProgressiveDeliveryCreate />
        </PageRoute>
      }
    />
    <Route
      path="calendar"
      element={
        <PageRoute
          userCapabilities={userCapabilities}
          pageInfo={{ title: 'Rollout Calendar' }}
        >
          <ProgressiveDeliveryCalendar />
        </PageRoute>
      }
    />
    <Route path="*" element={<Navigate to="/404" />} />
  </Route>
);
